import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useAtomValue, useSetAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import Lottie from 'lottie-react';

import { useGetNotice } from '@/app/manager/notice-setting/hooks/useGetNotice';

import '../animation.css';
import lottie from './lottie.json';

const LOCAL_STORAGE_KEY = 'lastClickDate-notice' as const;
const lastClickDateAtom = atomWithStorage(LOCAL_STORAGE_KEY, '');

/**
 * 미확인 공지 알림
 */
export function 미확인_공지_알림() {
  const { data: notice } = useGetNotice({ refetchInterval: 10 * 60 * 1000 });

  const lastClickDate = useAtomValue(lastClickDateAtom);
  const 새로운_공지가_등록되었는가 = dayjs(notice?.modifyDate).isAfter(dayjs(lastClickDate));

  if (lastClickDate && !새로운_공지가_등록되었는가) {
    return;
  }

  return <NoticeLottie />;
}

function NoticeLottie() {
  const { data: notice } = useGetNotice();

  const setLastClickDate = useSetAtom(lastClickDateAtom);

  const onClickNotice = () => {
    const lastClickDate = dayjs().toString();

    window.open(notice?.url);
    localStorage.setItem(LOCAL_STORAGE_KEY, lastClickDate);
    setLastClickDate(lastClickDate);
  };

  return (
    <div style={{ position: 'relative', top: 3, cursor: 'pointer' }} onClick={onClickNotice}>
      <Lottie animationData={lottie} loop={false} />
      <Typography
        className="fade-in-box"
        variant="Subtitle_Looko"
        color="primary.main"
        position={'absolute'}
        style={{
          top: 8,
          left: 40,
        }}
      >
        미확인 공지 1건
      </Typography>
    </div>
  );
}
